import { render, staticRenderFns } from "./notification-area.vue?vue&type=template&id=2a9ac56d&"
import script from "./notification-area.vue?vue&type=script&lang=js&"
export * from "./notification-area.vue?vue&type=script&lang=js&"
import style0 from "./notification-area.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9ac56d')) {
      api.createRecord('2a9ac56d', component.options)
    } else {
      api.reload('2a9ac56d', component.options)
    }
    module.hot.accept("./notification-area.vue?vue&type=template&id=2a9ac56d&", function () {
      api.rerender('2a9ac56d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/notification-area.vue"
export default component.exports